import Cart from "./cart";
import {listener} from "../../../../../modules/vegas/js/util";

listener('change', '[data-save-cart-info]', (el, e) => {
	let params = {};
	params[el.dataset.saveCartInfo] = el.value;
	new Cart().saveCartInfo(params);
})
